<template>
  <div class="app-root-shell">
    <router-view></router-view>
  </div>
</template>

<script>
import { carregarDadosIniciais } from '@/state/globalData';
const NOTIFICATION_EVENTS = ["click", "keydown"];

export default {
  name: "App",

  data() {
    return {
      modalForm: false,
      screenWidth: window.innerWidth,
      isMobile: false,
      notificationStatus: null, // "default" | "granted" | "denied" | "unsupported"
      notificationRequestInProgress: false,
    };
  },

  mounted() {
    if (localStorage.getItem('userid')) {
      carregarDadosIniciais();
    }
    // 1) Checa suporte
    if (typeof window === "undefined" || !("Notification" in window)) {
      this.notificationStatus = "unsupported";
      console.log("Notifications não são suportadas neste navegador.");
    } else {
      this.notificationStatus = Notification.permission;
      console.log("Notification.permission:", this.notificationStatus);

      // 2) Se ainda não decidiu, arma listeners para esperar um gesto do usuário
      if (this.notificationStatus === "default") {
        this.setupNotificationPermissionOnUserGesture();
      }
    }

  },

  beforeUnmount() {
    this.removeNotificationListeners();
  },

  methods: {
    // ---------- NOTIFICAÇÃO: esperar gesto do usuário ----------

    setupNotificationPermissionOnUserGesture() {
      if (this.notificationRequestInProgress) return;

      NOTIFICATION_EVENTS.forEach((evt) => {
        window.addEventListener(evt, this.handleUserGestureForNotification, {
          once: false,
        });
      });
    },

    removeNotificationListeners() {
      NOTIFICATION_EVENTS.forEach((evt) => {
        window.removeEventListener(evt, this.handleUserGestureForNotification);
      });
    },

    handleUserGestureForNotification() {
      // garante que só roda uma vez
      if (this.notificationRequestInProgress) return;
      this.notificationRequestInProgress = true;

      // não precisamos mais dos listeners depois da primeira interação
      this.removeNotificationListeners();

      if (!("Notification" in window)) {
        this.notificationStatus = "unsupported";
        this.notificationRequestInProgress = false;
        return;
      }

      // se o estado mudou antes de chegarmos aqui, não faz nada
      if (Notification.permission !== "default") {
        this.notificationStatus = Notification.permission;
        this.notificationRequestInProgress = false;
        return;
      }

      // ⚠️ chamado DIRETAMENTE no handler de click/keydown (gesto do usuário)
      Notification.requestPermission()
          .then(async (permission) => {
            this.notificationStatus = permission;
            console.log("Permissão de notificação após gesto:", permission);

            if (permission === "granted") {
              console.debug("✅ Permissão concedida!");
              try {
                const registration = await navigator.serviceWorker.ready;
                registration.showNotification("Bem-vindo 👋", {
                  body: "Notificações ativas!",
                  icon: "/images/cau_logo.svg",
                });
              } catch (err) {
                console.error("Erro ao mostrar notificação de boas-vindas:", err);
              }
            } else {
              console.warn("❌ Permissão negada ou ignorada.");
            }
          })
          .catch((err) => {
            console.error("Erro ao pedir permissão:", err);
          })
          .finally(() => {
            this.notificationRequestInProgress = false;
          });
    },

    // ---------- Métodos extras opcionais ----------

    async pedirPermissao() {
      if (!("Notification" in window)) {
        alert("Seu navegador não suporta notificações.");
        return;
      }

      const permission = await Notification.requestPermission();
      this.notificationStatus = permission;

      if (permission === "granted") {
        alert("Permissão concedida!");
      } else {
        alert("Permissão negada!");
      }
    },

    async enviarNotificacao() {
      if (Notification.permission !== "granted") {
        alert("Peça permissão primeiro!");
        return;
      }

      const registration = await navigator.serviceWorker.ready;

      registration.showNotification("Notificação Vue CLI", {
        body: "Essa é uma notificação local 😄",
        icon: "/icons/icon-192x192.png",
        data: "https://vuejs.org",
      });
    },
  },
};
</script>

<style>
html,
body,
#app {
  min-height: 100%;
  width: 100%;
}

.app-root-shell {
  min-height: 100vh;
  width: 100%;
}

.custom-toast-card {
  background-color: #202328 !important; /* Um verde mais corporativo */
}
</style>
